// 14 guider under /kunskapsbank/{slug}/
import { IMAGES } from "./company.js";
import { GUIDE_CONTENT } from "./guideContent.js";

const ALL_GUIDES = [
  {
    slug: "nar-ar-det-dags-att-byta-tak",
    title: "När ska man byta tak? Tecken att kontrollera | TISAB",
    metaDescription: "Laga eller byta tak? Jämför tecken på skador, möjliga åtgärder och vilket underlag du behöver för att fatta ett välgrundat takbeslut.",
    h1: "När är det dags att byta tak?",
    intro: "Att veta när det är dags att byta tak handlar om att känna igen tecknen på att takets ytskikt och underlag närmar sig sin tekniska livslängd. Här går vi igenom vad du ska leta efter – och när en besiktning är ett bra nästa steg.",
    sections: [
      { h2: "Tecken på att taket behöver bytas", body: "Vanliga tecken är synliga skador, upprepade läckage, slitet ytskikt, rost på plåt, skadade pannor och att underlaget inte längre håller för en renovering. Om flera av dessa sammanfaller kan ett byte vara aktuell." },
      { h2: "Ålder och material", body: "Takets tekniska livslängd varierar med material, läge, underhåll och utförande. Vi anger inga generella livslängder som gäller alla tak – en besiktning ger ett konkret underlag för just ditt tak." },
      { h2: "Reparera, renovera eller byta?", body: "Vid avgränsade skador kan en reparation räcka. Om ytskiktet är slitet men underlaget intakt kan renovering vara rätt. Om både underlag och ytskikt är uttjänat är ett byte aktuell. En besiktning hjälper dig välja." },
    ],
    faq: [
      { q: "Hur gammalt får ett tak vara?", a: "Det beror på material, läge och underhåll. Vi ger inga generella livslängder – en besiktning bedömer ditt tak." },
      { q: "Måste jag byta om det läcker?", a: "Inte nödvändigtvis. En avgränsad skada kan ofta repareras. Upprepade läckage eller slitet underlag talar för renovering eller byte." },
    ],
    relatedServices: ["takbesiktning", "byta-tak", "takrenovering", "takreparation"],
    image: IMAGES.villaMetal,
  },
  {
    slug: "vad-kostar-ett-takbyte",
    title: "Kostnad för takbyte – jämför pris & offert | TISAB",
    metaDescription: "Förstå hur ett takbyte prissätts: takyta, underarbete, material, plåt, åtkomst och ROT. Använd checklistan för att jämföra takofferter.",
    h1: "Vad kostar ett takbyte?",
    intro: "Priset på ett takbyte beror på många faktorer. Vi visar inga exakta priser som inte är verifierade, men vi förklarar vad som driver kostnaden så att du kan jämföra offerter på rätt sätt.",
    sections: [
      { h2: "Vad påverkar priset", body: "Takyta, takets form och lutning, nuvarande och nytt material, underarbete, råspont, ställning, genomföringar, kupor, skorstenar, plåtdetaljer, avvattning, taksäkerhet, åtkomst och eventuella skador." },
      { h2: "ROT-avdrag", body: "Du kan ha rätt till ROT-avdrag för en del av arbetskostnaden. Material och resor ger inte rätt till avdrag. Ditt skatteutrymme och aktuella regler påverkar avdraget. Kontrollera aktuella regler hos Skatteverket." },
      { h2: "Offertunderlag i stället för priskalkyl", body: "Vi ger ett offertunderlag där du fyller i ditt taks förutsättningar – inte en bindande priskalkyl. Det ger ett relevant underlag utan generiska schablonpriser." },
    ],
    faq: [
      { q: "Kan ni ge ett pris per kvadratmeter?", a: "Vi publicerar inte generiska kvadratmeterpriser. Priset beror på för många faktorer för att ett standardpris ska vara rättvisande." },
      { q: "Påverkar ROT-avdraget priset?", a: "ROT-avdraget kan minska din nettokostnad för arbete. Aktuella regler och belopp kontrollerar du hos Skatteverket." },
    ],
    relatedServices: ["pris-pa-tak", "byta-tak", "delbetalning", "takrenovering"],
    image: IMAGES.villaMetal,
  },
  {
    slug: "takbyte-100-150-200-kvm",
    title: "Takbyte 100, 150 & 200 kvm – Vad Påverkar Kostnaden | TISAB",
    metaDescription: "Takbyte på 100, 150 eller 200 kvm? TISAB förklarar hur takyta, form, material och underarbete påverkar kostnaden. Begär offertunderlag för din takyta.",
    h1: "Takbyte på 100, 150 och 200 kvm",
    intro: "Takyta är en av flera prisdrivare, men sällan den enda. Här förklarar vi hur takyta samspelar med form, lutning, material och underarbete – och varför en offert utifrån ditt tak är mer rättvisande än ett standardpris per kvm.",
    sections: [
      { h2: "Takyta och takets form", body: "Ett enkelt sadeltak på 150 kvm är snabbare att lägga än ett valmat tak med många nockar och falsar på samma yta. Formen påverkar både materialåtgång och arbetstid." },
      { h2: "Material och underarbete", body: "Valet mellan plåt, papp, tegel och betongpannor påverkar både material- och arbetskostnad. Underarbete som råspont, läkt och underlagspapp tillkommer vid behov." },
      { h2: "Andra faktorer", body: "Genomföringar, kupor, skorstenar, plåtdetaljer, avvattning, taksäkerhet, åtkomst och eventuella skador påverkar den totala kostnaden." },
    ],
    faq: [
      { q: "Kostar ett takbyte på 200 kvm dubbelt så mycket som 100 kvm?", a: "Inte nödvändigtvis. Större tak kan ha lägre kostnad per kvm, men form, material och underarbete påverkar mer än ytan ensam." },
      { q: "Hur får jag ett pris för min takyta?", a: "Begär ett offertunderlag där du anger din ungefärliga takyta – vi bedömer utifrån ditt tak." },
    ],
    relatedServices: ["pris-pa-tak", "byta-tak", "takrenovering"],
    image: IMAGES.villaMetal,
  },
  {
    slug: "valja-takmaterial",
    title: "Välja takmaterial – så jämför du alternativen | TISAB",
    metaDescription: "Jämför lertegel, betongpannor, plåt och takpapp. Se hur konstruktion, lutning, underlag och underhåll påverkar materialvalet.",
    h1: "Välja takmaterial",
    intro: "Valet av takmaterial påverkar utseende, livslängd, underhåll och pris. Här jämför vi de vanligaste materialen och förklarar när de passar – så att du får ett underlag för ditt val.",
    sections: [
      { h2: "Plåt", body: "Plåt är lätt, hållbart och passar många lutningar. Falsad plåt och bandtäckning ger täta skarvar. Plåttak kan målas när färgen slits." },
      { h2: "Papp", body: "Takpapp passar platta och svagt lutande tak. Tätskiktet anpassas efter konstruktion och lutning." },
      { h2: "Lertegel och betongpannor", body: "Lertegel ger ett klassiskt utseende; betongpannor är en hållbar panna med färg i massan. Båda kräver rätt underarbete och lutning." },
    ],
    faq: [
      { q: "Vilket material är billigast?", a: "Det beror på takets förutsättningar. Vi ger materialrådgivning utifrån ditt tak och din budget." },
      { q: "Kan jag byta material vid takbyte?", a: "Ja, ofta kan du välja ett nytt material, men konstruktion och lutning styr vad som är möjligt." },
    ],
    relatedServices: ["takmaterial", "byta-tak", "plattak", "papptak", "tegeltak"],
    image: IMAGES.tileDetail,
  },
  {
    slug: "plattak-pris-egenskaper-underhall",
    title: "Plåttak – Pris, Egenskaper & Underhåll | TISAB",
    metaDescription: "Plåttak – egenskaper, underhåll och vad som påverkar priset. TISAB har egen plåtverkstad och lägger, reparerar och målar plåttak i Stockholm. Läs guiden.",
    h1: "Plåttak – pris, egenskaper och underhåll",
    intro: "Plåttak är vanligt i Sverige och finns i flera utföranden. Här går vi igenom typer, egenskaper, underhåll och vad som påverkar priset på ett plåttak.",
    sections: [
      { h2: "Typer av plåttak", body: "Falsad plåt fogas genom falsning, bandtäckning läggs i långa banor, och profilplåt har profilerade mönster. Valet styrs av lutning, utseende och användning." },
      { h2: "Egenskaper", body: "Plåt är lätt, hållbart och tåligt. Vikt och konstruktion gör att plåt ofta passar tak där tyngre material skulle kräva förstärkning." },
      { h2: "Underhåll och målning", body: "Plåttak kan behöva målas när färgen slits eller rost uppstår. Rätt förarbete och färgsystem förlänger livslängden. Ibland behöver taket i stället repareras eller bytas." },
    ],
    faq: [
      { q: "Hur tungt är ett plåttak?", a: "Plåt är ett av de lättaste takmaterialen, vilket kan minska kravet på bärkonstruktion." },
      { q: "Hur ofta ska plåttaket målas?", a: "Det varierar med läge och skick. En kontroll visar när målning är aktuell." },
    ],
    relatedServices: ["plattak", "takmalning/plattak", "platslageri", "takrenovering"],
    image: IMAGES.metalDetail,
  },
  {
    slug: "papptak-pris-renovering-underhall",
    title: "Papptak – Pris, Renovering & Underhåll | TISAB",
    metaDescription: "Papptak – renovering, underhåll och vad som påverkar priset. TISAB lägger, omlägger och renoverar papptak i Stockholm. Läs guiden och begär offert.",
    h1: "Papptak – pris, renovering och underhåll",
    intro: "Papptak är vanligt på platta och svagt lutande tak. Här går vi igenom när papptak kan renoveras, vad som påverkar priset och hur underhållet fungerar.",
    sections: [
      { h2: "När passar papptak", body: "Papptak passar platta och svagt lutande tak där tätskiktet kan läggas i skikt anpassade till lutningen." },
      { h2: "Renovering och omläggning", body: "Vid mindre skador kan tätning eller partiell omläggning räcka. Vid omfattande slitage rekommenderas omläggning eller byte av tätskikt." },
      { h2: "Underhåll", body: "Håll avvattning och genomföringar fria, och kontrollera tätskiktet regelbundet. Ett serviceavtal kan ge löpande kontroll." },
    ],
    faq: [
      { q: "Kan man lägga ny papp på gammal?", a: "Det beror på underlagets skick. Ofta rekommenderas demontering av gammalt material innan nytt läggs." },
      { q: "Hur ofta ska papptaket ses över?", a: "En årlig kontroll av avvattning och tätskikt är en god rutin." },
    ],
    relatedServices: ["papptak", "takrenovering", "takreparation", "takservice"],
    image: IMAGES.metalDetail,
  },
  {
    slug: "tegeltak-eller-betongpannor",
    title: "Tegeltak eller Betongpannor – Jämförelse | TISAB",
    metaDescription: "Tegeltak eller betongpannor? TISAB jämför lertegel och betongpannor – utseende, vikt, egenskaper och pris. Materialrådgivning som del av offerten.",
    h1: "Tegeltak eller betongpannor?",
    intro: "Lertegel och betongpannor är två vanliga pannmaterial. Här jämför vi dem så att du får ett underlag för ditt val – men valet styrs alltid av din taks konstruktion.",
    sections: [
      { h2: "Lertegel", body: "Lertegel är bränd lera med klassiskt utseende. Det är ett traditionellt material med lång historia på svenska tak." },
      { h2: "Betongpannor", body: "Betongpannor är gjutna med färg i massan. De är en hållbar panna till ett konkurrenskraftigt pris." },
      { h2: "Vikt och konstruktion", body: "Båda materialen är tunga och kräver en bärkonstruktion som klarar vikten. Vi bedömer din konstruktion innan rekommendation." },
    ],
    faq: [
      { q: "Vilket material håller längst?", a: "Vi anger inga generella livslängder. Båda är hållbara material – en besiktning bedömer ditt tak." },
      { q: "Kan jag byta från betongpannor till lertegel?", a: "Det beror på om konstruktionen klarar viktskillnaden. Vi bedömer detta." },
    ],
    relatedServices: ["tegeltak", "takmaterial/betongpannor", "takmaterial", "byta-tak"],
    image: IMAGES.tileDetail,
  },
  {
    slug: "mala-plattak",
    title: "Måla Plåttak – Rostskydd & När Det Behövs | TISAB",
    metaDescription: "Måla plåttak – när behövs det och hur går det till? TISAB kontrollerar rost, färgskikt och förarbete innan målning. Läs guiden och begär offert.",
    h1: "Måla plåttak",
    intro: "Att måla ett plåttak kan förlänga livslängden om materialet är i gott skick. Här går vi igenom när målning är aktuell och vad som ingår i förarbetet – utan farliga gör-det-själv-instruktioner.",
    sections: [
      { h2: "När bör plåttaket målas", body: "Vid rost eller flagnande färg där plåten i övrigt är intakt kan målning vara rätt. Vid tunt eller skadat material kan reparation eller byte behövas." },
      { h2: "Förarbete", body: "Rätt förarbete – rengöring, rostbehandling och bedömning av befintligt färgsystem – avgör resultatets hållbarhet." },
      { h2: "När taket i stället behöver åtgärdas", body: "Om plåten är genomrostig eller tunn är målning inte tillräckligt. Då behöver taket repareras eller bytas." },
    ],
    faq: [
      { q: "Kan jag måla plåttaket själv?", a: "Takmålning med rostskydd kräver rätt utrustning och säkerhet. Vi avråder från farliga gör-det-själv-insatser på taket." },
      { q: "Vilken färg används?", a: "Vi använder ett färgsystem anpassat till materialet och det befintliga färgskiktet." },
    ],
    relatedServices: ["takmalning/plattak", "takmalning", "takreparation", "takrenovering"],
    image: IMAGES.metalDetail,
  },
  {
    slug: "tecken-pa-takskador",
    title: "Tecken på takskador – fukt, läckage & slitage | TISAB",
    metaDescription: "Läckage, skadade pannor eller rost på taket? Lär dig dokumentera synliga tecken säkert och förbereda rätt frågor inför en takbedömning.",
    h1: "Tecken på takskador",
    intro: "Att upptäcka takskador i tid kan minska omfattningen av åtgärden. Här går vi igenom vanliga tecken på att taket behöver ses över.",
    sections: [
      { h2: "Inuti huset", body: "Vattenmärken på tak eller väggar, fukt på vind och missfärgade ytor kan vara tecken på läckage." },
      { h2: "På taket", body: "Lossa eller skadade pannor, rost på plåt, sliten papp och problem med hängrännor och stuprör." },
      { h2: "Vad du ska göra", body: "Kontakta en takläggare för en besiktning eller felsökning. En tidig åtgärd är ofta mindre omfattande." },
    ],
    faq: [
      { q: "Måste jag upp på taket för att hitta skador?", a: "Nej, många tecken syns inuti eller från marken. Vid misstanke rekommenderar vi en besiktning." },
      { q: "Är ett litet vattenmärke farligt?", a: "Det kan vara början på en skada. Låt oss felsöka så att det inte växer." },
    ],
    relatedServices: ["takbesiktning", "takreparation", "takservice", "takrenovering"],
    image: IMAGES.rooferWork,
  },
  {
    slug: "takbesiktning-infor-solceller",
    title: "Solceller på taket? Kontrollera skicket först | TISAB",
    metaDescription: "Takbesiktning inför solceller: förstå takets skick, åtgärdsbehov och vilket ytterligare underlag som behövs innan installationen planeras.",
    h1: "Takbesiktning inför solcellsinstallation",
    intro: "Innan en solcellsinstallation kan det vara klokt att bedöma takets skick – så att taket inte behöver bytas efter att panelerna monterats. TISAB erbjuder inte solcellsinstallation, men vi kan besikta taket i förväg.",
    sections: [
      { h2: "Varför besiktiga före solceller", body: "Om taket behöver bytas är det mer kostnadseffektivt att göra det innan panelerna är på plats. En besiktning ger underlag för beslutet." },
      { h2: "Vad vi kontrollerar", body: "Ytskiktets skick, underlag, avvattning, taksäkerhet och takets återstående tekniska livslängd." },
      { h2: "Efter besiktningen", body: "Du får ett åtgärdsförslag – om taket kan behållas, renoveras eller bör bytas innan solceller." },
    ],
    faq: [
      { q: "Installerar ni solceller?", a: "Nej, TISAB installerar inte solceller. Vi besiktigar taket så att du vet dess skick innan installation." },
      { q: "Måste taket bytas innan solceller?", a: "Inte alltid. En besiktning visar om taket håller för en solcellsinstallation." },
    ],
    relatedServices: ["takbesiktning", "byta-tak", "takrenovering"],
    image: IMAGES.brfAerial,
  },
  {
    slug: "underhall-av-tak-aret-runt",
    title: "Takunderhåll året runt – säsongernas checklista | TISAB",
    metaDescription: "Planera takunderhåll under året. Kontrollera avvattning och synliga skador säkert, dokumentera förändringar och jämför serviceavtal.",
    h1: "Underhåll av tak året runt",
    intro: "Förebyggande underhåll förlänger takets livslängd och minskar risken för akuta skador. Här är en checklista för taket över året.",
    sections: [
      { h2: "Vår och höst", body: "Rensa hängrännor och stuprör från löv och skräp. Kontrollera att avvattningen är fri och att inga pannor har lossat." },
      { h2: "Vinter", body: "Övervaka snö och is. Vid behov kan takskottning och istappsborttagning aktualliseras – gärna via ett bevakat vinteravtal." },
      { h2: "Sommar", body: "Ett tillfälle att planera eventuell renovering eller målning innan vintern. En besiktning ger underlag." },
    ],
    faq: [
      { q: "Behöver jag ett serviceavtal?", a: "För BRF och företag är det en trygg rutin. Privat kan en årlig kontroll räcka." },
      { q: "Vem ansvarar för snörasskydd?", a: "Ansvaret varierar med fastighetstyp. Se vår guide om takskottning." },
    ],
    relatedServices: ["takservice", "serviceavtal", "snoskottning", "takbesiktning"],
    image: IMAGES.rooferWork,
  },
  {
    slug: "taksakerhet-takstege-snorasskydd",
    title: "Taksäkerhet – Takstege & Snörasskydd | TISAB",
    metaDescription: "Taksäkerhet – takstege, snörasskydd och fallskydd. TISAB installerar och kontrollerar taksäkerhet som del av takprojekt och serviceavtal. Läs guiden.",
    h1: "Taksäkerhet – takstege och snörasskydd",
    intro: "Taksäkerhet skyddar både de som vistas vid fastigheten och de som arbetar på taket. Här går vi igenom vad taksäkerhet innefattar – utan att sälja produkter i en falsk butik.",
    sections: [
      { h2: "Takstege och fotbräda", body: "Takstege och fotbräda underlättar säker framkomlighet på taket. De ingår ofta vid takbyte eller renovering." },
      { h2: "Snörasskydd", body: "Snörasskydd hindrar snö från att rasa ner. Placering och omfattning anpassas efter takets lutning och läge." },
      { h2: "Som del av service", body: "Taksäkerhet kontrolleras vid besiktning, service och inom serviceavtal." },
    ],
    faq: [
      { q: "Säljer ni takstege och snörasskydd separat?", a: "Vi installerar taksäkerhet som del av takprojekt och service – inte som en separat produktbutik." },
      { q: "Måste jag ha snörasskydd?", a: "Det beror på takets lutning och läge. Vi bedömer vad som behövs." },
    ],
    relatedServices: ["takservice", "serviceavtal", "byta-tak", "takbesiktning"],
    image: IMAGES.brfAerial,
  },
  {
    slug: "takrenovering-for-brf",
    title: "Takrenovering i BRF – styrelsens beslutsunderlag | TISAB",
    metaDescription: "Upphandla takrenovering i en BRF: status, budgetposter, jämförbara offerter, etapper, boendeinformation och överlämning. Praktiskt styrelseunderlag.",
    h1: "Takrenovering för BRF",
    intro: "En takrenovering i en bostadsrättsförening behöver börja med rätt frågor: vilket skick har taket, vad behöver åtgärdas och vilket underlag behöver styrelsen för att kunna ta beslut?",
    sections: [
      { h2: "Börja med takets faktiska skick", body: "En takbesiktning kan beskriva synliga brister, möjliga orsaker och vilka delar som behöver undersökas vidare. Det ger styrelsen ett sakligare utgångsläge inför budget och offert." },
      { h2: "Avgränsa vad beslutet ska omfatta", body: "Takets ytskikt, underlag, plåt, avvattning, genomföringar, åtkomst och antal byggnader påverkar omfattningen. Underlaget behöver vara tydligt nog för att offerter ska gå att jämföra." },
      { h2: "Planera även tiden efter åtgärden", body: "Löpande kontroll och service kan minska risken att mindre brister växer. TISAB har tre verifierade serviceupplägg: Trygghet Tak – Komplett, Underhåll samt Snö & is." },
    ],
    faq: [
      { q: "Hur lång tid tar en BRF-renovering?", a: "Det beror på omfattning, antal byggnader, åtkomst och valda åtgärder. En tidplan behöver tas fram för det enskilda projektet." },
      { q: "Behöver styrelsen en besiktning först?", a: "En besiktning kan ge styrelsen ett tydligare underlag inför budget, offert och beslut." },
    ],
    relatedServices: ["takbesiktning", "serviceavtal"],
    image: IMAGES.brfAerial,
  },
  {
    slug: "takskottning-ansvar-sno-och-is",
    title: "Snö & is på taket – ansvar och vinterplanering | TISAB",
    metaDescription: "Planera för snö och is på tak. Läs om fastighetsägarens ansvar, säkert agerande och frågor inför avropsavtal eller bevakat vinteravtal.",
    h1: "Takskottning – ansvar, snö och is",
    intro: "Takskottning skyddar taket och de som rör sig vid fastigheten. Här förklarar vi vad som ingår och var ansvar kan ligga – utan att lova jour dygnet runt.",
    sections: [
      { h2: "När behövs takskottning", body: "Vid stora snömängder, risk för istappar eller när snöbelastningen närmar sig takets kapacitet." },
      { h2: "Avropsavtal eller bevakat vinteravtal", body: "Med avropsavtal skottar vi på begäran; med bevakat vinteravtal övervakar vi läget och agerar vid behov." },
      { h2: "Ansvar", body: "Ansvaret för snö och is varierar med fastighetstyp och avtal. Vi hjälper BRF och fastighetsägare att välja rätt upplägg." },
    ],
    faq: [
      { q: "Har ni jour dygnet runt?", a: "Nej, vi erbjuder avropsavtal och bevakat vinteravtal – inte jour dygnet runt." },
      { q: "Vem ansvarar för istappar?", a: "Det beror på fastighetstyp och avtal. Ett bevakat vinteravtal kan ingå ansvarsbevakning." },
    ],
    relatedServices: ["snoskottning", "serviceavtal", "takservice", "takreparation"],
    image: IMAGES.brfAerial,
  },
];

const PUBLISHED_GUIDE_SLUGS = [
  "nar-ar-det-dags-att-byta-tak",
  "vad-kostar-ett-takbyte",
  "valja-takmaterial",
  "tecken-pa-takskador",
  "takbesiktning-infor-solceller",
  "underhall-av-tak-aret-runt",
  "takrenovering-for-brf",
  "takskottning-ansvar-sno-och-is",
];

const SERVICE_ALIASES = { takrenovering: "byta-tak", takreparation: "takservice", "takmalning/plattak": "takmalning", takentreprenad: "taklaggare" };
export const GUIDES = ALL_GUIDES.filter((guide) => PUBLISHED_GUIDE_SLUGS.includes(guide.slug)).map((guide) => {
  const content = GUIDE_CONTENT[guide.slug];
  return {
    ...guide,
    ...content,
    intro: content.intro || guide.intro,
    sections: content.sections.map(section => ({ ...section, h2: section.title })),
    relatedServices: [...new Set((guide.relatedServices || []).map(slug => SERVICE_ALIASES[slug] || slug))],
  };
});

export const getGuide = (slug) => GUIDES.find((g) => g.slug === slug);